import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './UserProfileDropdown.css';
import { Modal, Form, Input, Button, message, Typography, Row, Col,  } from 'antd';
import { getIframesToken, IS_GUIDELINE_GPT, IS_IFRAMES, PATH_CUSTOMER_ID } from 'MortgageGPT/constants';
import UserProfileModal from './UserProfileModal';
import { useTrackEvent } from '../../analytics/useTrackEvent';

const UserProfileDropdown = ({ 
    profile,
    setShowSelfPayUpgradeModal,
    onCheckOut,
    companyPayMode,
    currentBillingStatus,
    portalSessionUrl,
    promoCodeValidity,
    setApplyPromoCode,
    setTriggerType,
    downgradedTime,
    isMobile,
}) => {
    const { TextArea } = Input;
    const [isOpen, setIsOpen] = useState(false);
    const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
    const [messageReceivedModalOpen, setMessageReceivedModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('account');
    const [showUserProfileModal, setShowUserProfileModal] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const [support] = Form.useForm();
    const { trackHeaderUpgradeClicked, trackBillingUpgradeClicked } = useTrackEvent();
    
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleAvatarClick = () => {
        setIsOpen(!isOpen);
    };

    const handleAccountClick = () => {
        setShowUserProfileModal(true);
        setActiveTab('account');
    };

    const handleBillingClick = () => {
        setShowUserProfileModal(true);
        setActiveTab('billing');
    };

    const handleUpgradeClick = () => {
        // Track header upgrade clicked (when called from header/dropdown)
        if (activeTab === 'billing') {
            trackBillingUpgradeClicked(profile);
            setTriggerType('billing-cta');
        } else {
            trackHeaderUpgradeClicked(profile);
            setTriggerType('header-cta');
        }
        
        if (currentBillingStatus === 'past_due') {
            // window.location.href = portalSessionUrl;
            setShowUserProfileModal(false);
            setShowSelfPayUpgradeModal(true);
        } else if (currentBillingStatus === 'inactive' && promoCodeValidity === 'valid' && PATH_CUSTOMER_ID === 'successlending') {
            setTriggerType('promo-code-applied');
            setApplyPromoCode(true);
            setShowUserProfileModal(false);
            setShowSelfPayUpgradeModal(true);
        } else {
            setShowUserProfileModal(false);
            setShowSelfPayUpgradeModal(true);
        }
    };

    const handleContactClick = () => {
        setIsSupportModalOpen(true);
    };

    const handleSignOutClick = () => {
        dispatch({ type: 'SHOW_PDF', data: true });
        dispatch({ type: 'CHANGE_PDF', data: undefined });
        dispatch({ type: 'PAGE_LOADING', data: true });
        if(IS_GUIDELINE_GPT){
            [
            "lastUsedGuideline",
            "activeGPTmode",
            "selectedFilters",
            "selectedFiltersScenario",
            "selectedGuidelines",
            "selectedPrograms",
            "scenario_tag",
            "scenario_guideline",
            "scenario_lender_expand",
            "ZeitroA",
            'notif-lenders'
            ].forEach((k) => sessionStorage.removeItem(k));
            window.location.href = '/guidelinegpt'
        }else{
            localStorage.removeItem(getIframesToken());
            window.location.href = '/guidelinegpt/workflow/' + PATH_CUSTOMER_ID;
        }
    };

    const onSupportFinish = (val) => {
        let token = localStorage.getItem(getIframesToken())
        fetch('/los/customersupporttoslack', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${IS_IFRAMES ? token : sessionStorage.getItem("ZeitroA")}`,
                Cache: "no-cache"
            },
            body: JSON.stringify({
                Message: val.message
            })
        }).then(async response => {
            if (!response.ok) {
                return
            }
        })
        setIsSupportModalOpen(false)
    }



    if (!profile || !profile.FirstName || !profile.LastName) {
        return (
            <div className="user-profile-dropdown">
                <div className="user-avatar-trigger">
                    <div className="user-avatar">
                        <div className="loading-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="user-profile-dropdown" ref={dropdownRef}>
            {/* Avatar Trigger */}
            <div 
                className="user-avatar-trigger"
                onClick={handleAvatarClick}
            >
                <div className="user-avatar">
                    {profile.FirstName.charAt(0) + profile.LastName.charAt(0)}
                </div>
            </div>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="user-profile-menu">
                    {/* User Info Section */}
                    <div className="user-info-section">
                        <div className="user-name-container">
                            <div className="user-name">{profile.FirstName} {profile.LastName}</div>
                            {profile.AccountTier === 'paid' && companyPayMode === 'self_pay' && <span className='name-plan-tag'>Business</span>}
                        </div>
                        <div className="user-email">{profile.Email}</div>
                    </div>

                    {/* Separator */}
                    <div className="menu-separator"></div>

                    {/* Navigation Links */}
                    {
                        companyPayMode === 'self_pay' ?
                        (profile.AccountTier === 'free' ?
                            (
                                isMobile ?
                                    <div className="menu-item" onClick={handleUpgradeClick}>
                                        <div className="menu-item-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_5005_52893)">
                                                    <path d="M6.6243 10.3342C6.56478 10.1034 6.44453 9.89289 6.27605 9.72441C6.10757 9.55592 5.89702 9.43567 5.6663 9.37615L1.5763 8.32148C1.50652 8.30168 1.44511 8.25965 1.40138 8.20178C1.35765 8.14391 1.33398 8.07335 1.33398 8.00082C1.33398 7.92828 1.35765 7.85772 1.40138 7.79985C1.44511 7.74198 1.50652 7.69996 1.5763 7.68015L5.6663 6.62482C5.89693 6.56535 6.10743 6.4452 6.2759 6.27684C6.44438 6.10849 6.56468 5.89808 6.6243 5.66748L7.67897 1.57748C7.69857 1.50743 7.74056 1.44571 7.79851 1.40175C7.85647 1.35778 7.92722 1.33398 7.99997 1.33398C8.07271 1.33398 8.14346 1.35778 8.20142 1.40175C8.25938 1.44571 8.30136 1.50743 8.32097 1.57748L9.37497 5.66748C9.43449 5.8982 9.55474 6.10875 9.72322 6.27723C9.8917 6.44571 10.1023 6.56597 10.333 6.62548L14.423 7.67948C14.4933 7.69888 14.5553 7.74082 14.5995 7.79887C14.6437 7.85691 14.6677 7.92786 14.6677 8.00082C14.6677 8.07378 14.6437 8.14472 14.5995 8.20277C14.5553 8.26081 14.4933 8.30275 14.423 8.32215L10.333 9.37615C10.1023 9.43567 9.8917 9.55592 9.72322 9.72441C9.55474 9.89289 9.43449 10.1034 9.37497 10.3342L8.3203 14.4242C8.3007 14.4942 8.25871 14.5559 8.20075 14.5999C8.1428 14.6439 8.07205 14.6677 7.9993 14.6677C7.92656 14.6677 7.85581 14.6439 7.79785 14.5999C7.73989 14.5559 7.69791 14.4942 7.6783 14.4242L6.6243 10.3342Z" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_5005_52893">
                                                    <rect width="16" height="16" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <span className="menu-item-text">Upgrade</span>
                                    </div>
                                :
                                    <></>
                            )
                        :
                            <div className="menu-item" onClick={handleBillingClick}>
                                <div className="menu-item-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M13.333 3.33301H2.66634C1.92996 3.33301 1.33301 3.92996 1.33301 4.66634V11.333C1.33301 12.0694 1.92996 12.6663 2.66634 12.6663H13.333C14.0694 12.6663 14.6663 12.0694 14.6663 11.333V4.66634C14.6663 3.92996 14.0694 3.33301 13.333 3.33301Z" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.33301 6.66699H14.6663" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <span className="menu-item-text">Billing</span>
                            </div>
                        ):(
                            <></>
                        )
                    }

                    <div className="menu-item" onClick={handleAccountClick}>
                        <div className="menu-item-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M12.6663 14V12.6667C12.6663 11.9594 12.3854 11.2811 11.8853 10.781C11.3852 10.281 10.7069 10 9.99967 10H5.99967C5.29243 10 4.61415 10.281 4.11406 10.781C3.61396 11.2811 3.33301 11.9594 3.33301 12.6667V14" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M7.99967 7.33333C9.47243 7.33333 10.6663 6.13943 10.6663 4.66667C10.6663 3.19391 9.47243 2 7.99967 2C6.52692 2 5.33301 3.19391 5.33301 4.66667C5.33301 6.13943 6.52692 7.33333 7.99967 7.33333Z" stroke="#222222" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <span className="menu-item-text">Account</span>
                    </div>

                    <div className="menu-item" onClick={handleContactClick}>
                        <div className="menu-item-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M2 4.66732C2 4.3137 2.14048 3.97456 2.39052 3.72451C2.64057 3.47446 2.97971 3.33398 3.33333 3.33398H12.6667C13.0203 3.33398 13.3594 3.47446 13.6095 3.72451C13.8595 3.97456 14 4.3137 14 4.66732M2 4.66732V11.334C2 11.6876 2.14048 12.0267 2.39052 12.2768C2.64057 12.5268 2.97971 12.6673 3.33333 12.6673H12.6667C13.0203 12.6673 13.3594 12.5268 13.6095 12.2768C13.8595 12.0267 14 11.6876 14 11.334V4.66732M2 4.66732L8 8.66732L14 4.66732" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <span className="menu-item-text">Support</span>
                    </div>

                    {/* Separator */}
                    <div className="menu-separator"></div>

                    {/* Sign Out */}
                    <div className="menu-item sign-out" onClick={handleSignOutClick}>
                        <div className="menu-item-icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <polyline points="16,17 21,12 16,7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <span className="menu-item-text">Sign out</span>
                    </div>
                </div>
            )}
            <Modal open={messageReceivedModalOpen} footer={null} onCancel={() => {
                setMessageReceivedModalOpen(false)
            }}>
                <div className='text-center p-5'>
                    <div><img src='/images/emailSent.svg' /></div>
                    <div className='User_modal_title my-3'>We've received your message</div>
                    <div className='title-5 text-center'>Thank you for reaching out. </div>
                    <div className='title-5 text-center'>We will get back to you via email as soon as possible.</div>
                    <Button type='primary' size='large' className='mt-4' onClick={() => setMessageReceivedModalOpen(false)}>Done</Button>
                </div>
            </Modal>
            <Modal 
                width={786}
                className='help-modal'
                open={isSupportModalOpen} 
                footer={null} 
                onCancel={() => {
                    setIsSupportModalOpen(false)
                }}
            >
                <div className='help-modal-content'>
                    <div className='help-modal-content-title'>How can we help?</div>
                    <div className='help-modal-content-tips'>For inquiries regarding product feedback or any issues encountered while using Zeitro, we’re here to assist you promptly.</div>

                    <Form
                        className='help-modal-form'
                        onFinish={onSupportFinish}
                        form={support}
                        style={{ marginTop: '20px' }}
                        layout='vertical'
                    >
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    className='help-modal-form-item'
                                    name="message"
                                    label="Message"
                                >
                                    <TextArea
                                        className='help-modal-form-item-textarea'
                                        placeholder="Please leave us a message..." 
                                        style={{ 
                                            height: '250px',
                                            resize: 'none'
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <div style={{fontFamily: 'Inter', color: '#6E6E70', width: '100%', textAlign: 'center', marginTop: 20, lineHeight: '20px', letterSpacing: '0.2px'}}>Alternatively, you could also email us at <span style={{color: '#325CEB'}}>support@zeitro.com</span></div>
                        </Row>

                        <div style={{width: '100%', display: 'flex', justifyContent: 'center', gap: '48px'}}>
                            <Button className='help-modal-btn cancel-btn' onClick={() => {
                                setIsSupportModalOpen(false)

                            }}>Cancel</Button>
                            <Button className='help-modal-btn send-btn' type='primary' htmlType="submit">Send Message</Button>

                        </div>
                    </Form>
                </div>
            </Modal>
            <UserProfileModal
                isOpen={showUserProfileModal}
                onClose={
                    () => {
                        setShowUserProfileModal(false)
                    }
                }
                profile={profile}
                onCheckOut={handleUpgradeClick}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                companyPayMode={companyPayMode}
                currentBillingStatus={currentBillingStatus}
                portalSessionUrl={portalSessionUrl}
                downgradedTime={downgradedTime}
            />
        </div>
    );
};

export default UserProfileDropdown;